import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const Measurement = forwardRef<SVGSVGElement, Partial<IconProps>>(function Measurement({
  styles,
  ...props
}, ref) {
  return <Icon title="Measurement Icon" description="Opposing arrows indicating length measurement" ref={ref} {...stylex.props(styles)} viewBox="0 0 36 36" {...props}>
        <path {...stylex.props(iconsStyles.lightElement)} d="M18 2.3a15.7 15.7 0 1 1 0 31.4 15.7 15.7 0 0 1 0-31.5Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M27.5 14.2A19.8 19.8 0 0 0 22 8.4c-.8-.4-1.7 0-1.8 1l-.3 2.5-9 .4c-.7 0-1.4.2-1.6.8L9 14.2c0 .6 0 1 .2 1.3.2.5.9.7 1.4.7 2.4.2 9 .5 15.8.1 1.1 0 1.7-1.2 1.1-2.1ZM8.5 21.8c1.2 1.8 3.1 4.3 5.6 5.8.8.4 1.7 0 1.8-1l.3-2.5 9-.4c.7 0 1.4-.2 1.6-.8l.2-1.1c0-.6 0-1-.2-1.3-.2-.5-.9-.7-1.4-.7-2.4-.2-9-.5-15.8-.1-1.1 0-1.7 1.2-1.1 2.1Z" />
      </Icon>;
});